import Header from '_v2/layouts/header';
import { Layout } from 'antd';
import Loading from 'components/shared-components/Loading';
import { Suspense } from 'react';
import Footer from './footer';

const { Content } = Layout;

export const AppLayout = ({ children }) => {
  return (
    <div className="tw-h-screen tw-flex tw-flex-col tw-overflow-hidden">
      <div className="tw-flex-shrink-0">
        <Header />
      </div>
      {/* The footer lives inside the scrollable region so it scrolls away with
          the page content instead of staying pinned to the bottom of the
          viewport. On short pages `tw-flex-1` on the content wrapper still
          pushes it to the bottom. */}
      <Content className="tw-flex-1 tw-min-h-0 tw-overflow-auto tw-flex tw-flex-col">
        <div className="tw-flex-1">
          <Suspense fallback={<Loading cover="content" />}>{children}</Suspense>
        </div>
        <Footer />
      </Content>
    </div>
  );
};

export default AppLayout;
